export const StaticRoutePaths = {
    LOGIN: `/login`,
    LOGIN_FORGOTTEN_PASSWORD: `/login/forgotten-password`,
    LOGIN_RESET_PASSWORD: `/login/reset-password`,

    CREATE_PASSWORD: `/create-password`,
    RESET_PASSWORD: `/reset-password`,

    HOME: `/`,

    USERS: `/users`,
    NEW_USER: `/users/add-user`,
    EDIT_USER: `/users/edit-user`,

    INFO_USER: `/users/user-information`,
    INFO_DETAILS_USER: `/users/user-information/user-details`,
    INFO_PASSWORD_USER:`/users/user-information/user-password`,

    COMPANIES: `/companies`,
    NEW_COMPANY: '/companies/add-company',
    EDIT_COMPANY: '/companies/edit-company',
    DETAILS_COMPANY: '/companies/company-details',

    INFO_COMPANY:`/companies/company-information`,
    INFO_NEW_COMPANY:`/companies/company-information/add-company`,
    INFO_EDIT_COMPANY:`/companies/company-information/edit-company`,

    PHARMACIES: `/pharmacies`,
    NEW_PHARMACY: '/pharmacies/add-pharmacy',
    EDIT_PHARMACY: '/pharmacies/edit-pharmacy',
    PHARMACY_DETAILS: '/pharmacies/pharmacy-details',
    ADD_PHARMACY_SERVICE: '/pharmacies/pharmacy-details/add-pharmacy-service',
    EDIT_PHARMACY_SERVICE: '/pharmacies/pharmacy-details/edit-pharmacy-service',

    STATISTICS: `/statistics`,
    ORDERS: `/orders`,
    ORDER_DETAILS: `/orders/order-details`,

    PATIENTS: `/patients`,
    NEW_PATIENT: `/patients/add-patient`,
    EDIT_PATIENT: `/patients/edit-patient`,
    DETAILS_PATIENT: `/patients/patient-details`,
};

export const RoutePaths = Object.freeze({
    LOGIN: () => StaticRoutePaths.LOGIN,

    HOME: () => StaticRoutePaths.HOME,

    USERS: () => StaticRoutePaths.USERS,
    NEW_USER: () => StaticRoutePaths.NEW_USER,
    EDIT_USER: id => `${StaticRoutePaths.EDIT_USER}/${id}`,

    COMPANIES: () => StaticRoutePaths.COMPANIES,
    NEW_COMPANY: () => StaticRoutePaths.NEW_COMPANY,
    EDIT_COMPANY: id => `${StaticRoutePaths.EDIT_COMPANY}/${id}`,
    DETAILS_COMPANY: id => `${StaticRoutePaths.DETAILS_COMPANY}/${id}`,

    PHARMACIES: () => StaticRoutePaths.PHARMACIES,
    NEW_PHARMACY: () => StaticRoutePaths.NEW_PHARMACY,
    EDIT_PHARMACY: id => `${StaticRoutePaths.EDIT_PHARMACY}/${id}`,
    PHARMACY_DETAILS: id => `${StaticRoutePaths.PHARMACY_DETAILS}/${id}`,
    ADD_PHARMACY_SERVICE: id => `${StaticRoutePaths.PHARMACY_DETAILS}/${id}/add-pharmacy-service`,
    EDIT_PHARMACY_SERVICE: (pharmacyId, serviceId) => `${StaticRoutePaths.PHARMACY_DETAILS}/${pharmacyId}/edit-pharmacy-service/${serviceId}`,

    STATISTICS: () => StaticRoutePaths.STATISTICS,
    ORDERS: () => StaticRoutePaths.ORDERS,
    ORDER_DETAILS: id => `${StaticRoutePaths.ORDER_DETAILS}/${id}`,

    PATIENTS: () => StaticRoutePaths.PATIENTS,
    NEW_PATIENT: () => StaticRoutePaths.NEW_PATIENT,
    EDIT_PATIENT: id => `${StaticRoutePaths.EDIT_PATIENT}/${id}`,
    PATIENT_DETAILS: id => `${StaticRoutePaths.DETAILS_PATIENT}/${id}`,
    DETAILS_PATIENT_PRINT: id => `${StaticRoutePaths.DETAILS_PATIENT}/${id}/print-page`
});



// WEBPACK FOOTER //
// ./src/customModules/Common/ClientRoutes.js